export default __webpack_public_path__ + "static/media/generali-red-logo-scaled.9794c7bd.png";